import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { HaloThemeProvider } from "./contexts/HaloThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { PartnerAuthProvider } from "./state/PartnerAuth";
import { AuthProvider } from "./contexts/AuthContext";
import { preloadCriticalResources, analyzeBundleSize } from "./utils/performance";
import "./index.css";
import App from "./App";

// Initialize performance optimizations
if (process.env.NODE_ENV === 'production') {
  // Preload critical resources in production
  preloadCriticalResources();
} else {
  // Analyze bundle size in development
  setTimeout(analyzeBundleSize, 2000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HaloThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <PartnerAuthProvider>
            <HashRouter>
              <App />
            </HashRouter>
          </PartnerAuthProvider>
        </AuthProvider>
      </LanguageProvider>
    </HaloThemeProvider>
  </React.StrictMode>,
);